import {UIMSceneEnum} from '../../../../../../shared/enums/UIMSceneEnums'
import {ClientUserState} from '../../../../../shared/scripts/ClientUserState'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {UIMSceneController} from '../../UIMSceneController'
import {getLobbyImagePath} from '../../../../../shared/scripts/ui_utils/Utils'
import {setElementOnClick} from '../../../../../shared/scripts/ui_utils/DomUtils'

export class UIMNavigationController {
    private readonly navigationContainer: HTMLDivElement
    private readonly animatedSlider: HTMLDivElement

    private readonly rankingTab: HTMLDivElement
    private readonly lobbyTab: HTMLDivElement
    private readonly playTab: HTMLDivElement
    private readonly storeTab: HTMLDivElement
    private readonly profileTab: HTMLDivElement

    private readonly sceneController: UIMSceneController

    constructor(sceneController: UIMSceneController) {
        this.navigationContainer = document.getElementById('bottom-nav-container') as HTMLDivElement
        this.animatedSlider = document.getElementById('bottom-nav-animated-slider') as HTMLDivElement

        this.rankingTab = document.getElementById('bottom-nav-ranking-tab') as HTMLDivElement
        this.lobbyTab = document.getElementById('bottom-nav-lobby-tab') as HTMLDivElement
        this.playTab = document.getElementById('bottom-nav-play-tab') as HTMLDivElement
        this.storeTab = document.getElementById('bottom-nav-store-tab') as HTMLDivElement
        this.profileTab = document.getElementById('bottom-nav-profile-tab') as HTMLDivElement

        this.sceneController = sceneController

        this.slideToTab()
        this.handleStoreFeatureHide()
        this.moveSliderTo(this.sceneController.scene ?? UIMSceneEnum.Homepage)

        ClientUserState.registerChangeListener(() => {
            UIMNavigationController.updateUserAvatar()
        })
    }

    private slideToTab() {
        const hideDetailsAndLoadScene = (scene: UIMSceneEnum) => {
            const detailsContainer = document.getElementById('mm-details-container') as HTMLDivElement
            detailsContainer.classList.add('hidden')
            this.sceneController.loadScene(scene)
        }

        setElementOnClick(this.rankingTab, () => hideDetailsAndLoadScene(UIMSceneEnum.Leaderboard))
        setElementOnClick(this.lobbyTab, () => hideDetailsAndLoadScene(UIMSceneEnum.Lobby))
        setElementOnClick(this.playTab, () => hideDetailsAndLoadScene(UIMSceneEnum.Homepage))
        setElementOnClick(this.storeTab, () => hideDetailsAndLoadScene(UIMSceneEnum.Store))
        setElementOnClick(this.profileTab, () => hideDetailsAndLoadScene(UIMSceneEnum.Profile))
    }

    private static updateUserAvatar() {
        if(ClientUserState.userState?.icon == undefined) return
        const userAvatarContainer = document.getElementById('bottom-nav-profile-tab') as HTMLDivElement
        const userAvatar = userAvatarContainer.querySelector('.bottom-nav-icon') as HTMLImageElement
        userAvatar.src = getLobbyImagePath(ClientUserState.userState.icon)
    }

    moveSliderTo(tab: UIMSceneEnum) {
        const leftPosition = UIMNavigationController.calculateSliderPosition(tab)
        this.animatedSlider.style.left = `${leftPosition}%`
        this.updateSelectedTab(tab)
    }

    private static calculateSliderPosition(tab: UIMSceneEnum): number {
        const isStoreHidden = UIUtilsEjsVariables.shouldHideStoreOnMobile

        const unselectedTabWidth = 1
        const selectedTabWidth = 1.7

        const tabCount = isStoreHidden ? 4 : 5
        const totalTabsWidth = (tabCount - 1) * unselectedTabWidth + selectedTabWidth
        const step = (unselectedTabWidth / totalTabsWidth) * 100

        const updatedTab = (isStoreHidden && tab == UIMSceneEnum.Profile) ? tab - 1 : tab
        return updatedTab * step
    }

    private updateSelectedTab(selectedScene: UIMSceneEnum) {
        this.rankingTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Leaderboard)
        this.lobbyTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Lobby)
        this.playTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Homepage)
        this.storeTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Store)
        this.profileTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Profile)
        this.updateTabSizing(selectedScene)
    }

    private updateTabSizing(selectedScene: UIMSceneEnum) {
        this.navigationContainer.classList.remove('tab-0-selected', 'tab-1-selected', 'tab-2-selected', 'tab-3-selected', 'tab-4-selected')
        this.navigationContainer.classList.add(`tab-${selectedScene}-selected`)
    }

    hide() {
        this.navigationContainer.style.display = 'none'
    }

    show() {
        this.navigationContainer.style.display = 'grid'
    }

    handleStoreFeatureHide() {
        if(UIUtilsEjsVariables.shouldHideStoreOnMobile != true) return
        this.navigationContainer.classList.add('store-hidden')
        this.storeTab.classList.add('hidden')
    }
}
